<template>
  <v-container
    id="locationToJobClassTab"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div v-show="!loading">
      <v-progress-linear
        v-show="savingData"
        indeterminate
        color="green"
      />
      <v-row>
        <v-col
          cols="6"
        >
          <base-resource-select
            label="Job Class"
            item-text="jobClassName"
            item-value="id"
            bind-text="jobClassName"
            bind-value="oeJobClassId"
            :bind-item="item"
            :error-messages="formErrors.OEJobClassId"
            :fetch-method="getJobClass"
            :disabled="disabled"
          />
        </v-col>
        <v-col
          v-if="disabled === false"
          cols="6"
        >
          <v-btn
            color="success"
            class="px-1 ml-1"
            fab
            x-small
            @click="add"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-btn
            color="info"
            class="px-1 ml-1"
            fab
            x-small
            @click="addAll"
          >
            All
          </v-btn>
        </v-col>
      </v-row>
      <v-divider
        class="mx-4"
        inset
      />
      <v-alert
        v-if="!jobClassListCount"
        type="info"
      >
        No job classes are assigned
      </v-alert>
      <v-card v-show="jobClassListCount">
        <v-list>
          <v-list-item
            v-for="(item, i) in jobClassList"
            :key="i"
          >
            <v-list-item-action
              v-if="disabled === false"
            >
              <v-btn
                color="error"
                class="px-1 ml-1"
                fab
                x-small
                @click="remove(item)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="item.jobClassName" />
              <v-list-item-subtitle v-text="item.jobClassDescription" />
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import { extractFormErrors, getErrorTitle } from '@/services/ErrorHandlers'

  export default {
    name: 'AssignJobClass',

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      location: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      loading: false,
      savingData: false,
      errorMessage: null,
      displayError: false,
      formErrors: {},

      jobClassList: [],
      item: {},

      locationJobClassResource: new TroodyApi('oeLocationOEJobClass/'),
      jobClassResource: new TroodyApi('oeJobClass/'),
    }),

    computed: {
      jobClassListCount () {
        let count = 0
        if (this.jobClassList && this.jobClassList.length) {
          count = this.jobClassList.length
        }
        return count
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadAssigned()
      },

      getJobClass () {
        return this.jobClassResource.query({ openEnrollmentId: this.openEnrollment.id })
      },

      loadAssigned () {
        this.loading = true
        this.locationJobClassResource.query({ openEnrollmentId: this.openEnrollment.id, oeLocationId: this.location.id })
          .then(data => {
            this.loading = false
            this.jobClassList = data
          })
          .catch((error) => {
            this.loading = false
            this.showError(error, 'Failed to load assigned job classes!')
          })
      },

      showError (error, msg) {
        this.loading = false
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },

      addAll () {
        this.savingData = true
        this.item.openEnrollmentId = this.openEnrollment.id
        this.item.oeLocationId = this.location.id

        this.locationJobClassResource.post(this.item, 'AddAll')
          .then((data) => {
            this.savingData = false
            this.jobClassList = data
            this.$emit('saved', this.jobClassList)
          })
          .catch((error) => {
            this.savingData = false
            this.formErrors = extractFormErrors(error)
            if (this.formErrors) {
              this.showError(getErrorTitle(error), 'Failed to add all!')
            } else {
              this.formErrors = {}
              this.showError(error, 'Failed to add all!')
            }
          })
      },

      add () {
        this.savingData = true
        this.item.openEnrollmentId = this.openEnrollment.id
        this.item.oeLocationId = this.location.id

        this.locationJobClassResource.save(this.item)
          .then((data) => {
            this.savingData = false
            if (!this.jobClassList) {
              this.jobClassList = []
            }
            this.jobClassList.push(data)
            this.$emit('saved', this.jobClassList)
          })
          .catch((error) => {
            this.savingData = false
            this.formErrors = extractFormErrors(error)
            if (this.formErrors) {
              this.showError(getErrorTitle(error), 'Failed to save!')
            } else {
              this.formErrors = {}
              this.showError(error, 'Failed to save!')
            }
          })
      },

      remove (record) {
        this.savingData = true
        this.locationJobClassResource.delete(record.id)
          .then((data) => {
            this.savingData = false

            // Rebuild the list with everything except the removed item
            this.jobClassList = this.jobClassList.filter((item) => {
              return item.id !== record.id
            })
          })
          .catch((error) => {
            this.savingData = false
            this.showError(error, 'Failed to delete!')
          })
      },

    },
  }
</script>
